import type { Contracts, ContractsApi, ContractsSearchFiltersFormValues, ContractsSearchParams } from '../../models';
import { normalizeContract } from '../get-contract';

type FormOption<T extends string | number> = { id: T; label: string };

export const toFormOption = <T extends string | number>(
  id: T | null | undefined,
  label?: string,
): FormOption<T> | null => {
  if (id === null || id === undefined) {
    return null;
  }

  return { id, label: label || '' };
};

export const toParamNumber = (value: string | number | null | undefined): number | undefined => {
  if (value === null || value === undefined) {
    return undefined;
  }

  return Number(value);
};

// Form objects -> URL params
export const normalizeContractFiltersUpdate = (filters: ContractsSearchFiltersFormValues): ContractsSearchParams => ({
  approvedOn: filters.approvedOn ?? undefined,
  cargoType: filters.cargoType?.id.toString(),
  carrierKey: toParamNumber(filters.carrierKey?.id),
  createdBy: toParamNumber(filters.createdBy?.id),
  customerLaneId: toParamNumber(filters.customerLaneId),
  destinationCity: filters.destinationCity ?? undefined,
  destinationCountry: filters.destinationCountry?.id.toString(),
  destinationPortName: filters.destinationPortName ?? undefined,
  destinationPortType: toParamNumber(filters.destinationPortType?.id),
  destinationPostalCode: filters.destinationPostalCode ?? undefined,
  destinationState: filters.destinationState?.id.toString(),
  effectiveFrom: filters.effectiveFrom || undefined,
  effectiveTo: filters.effectiveTo || undefined,
  modifiedBy: toParamNumber(filters.modifiedBy?.id),
  name: filters.contractName ?? undefined,
  originCity: filters.originCity ?? undefined,
  originCountry: filters.originCountry?.id.toString(),
  originPortName: filters.originPortName ?? undefined,
  originPortType: toParamNumber(filters.originPortType?.id),
  originPostalCode: filters.originPostalCode ?? undefined,
  originState: filters.originState?.id.toString(),
  pricingBasis: filters.pricingBasis?.id.toString(),
  pricingCategory: filters.pricingCategory?.id.toString(),
  pricingType: filters.pricingType?.id.toString(),
  serviceKey: toParamNumber(filters.serviceKey?.id),
  status: filters.status?.id.toString(),
  supplierDiversity: filters.supplierDiversity?.id.toString(),
  trailerKey: toParamNumber(filters.trailerKey?.id),
  transportationMode: filters.transportationMode?.id.toString(),
  uniqueName: filters.uniqueName ?? undefined,
});

export const normalizeContracts = async (contracts: ContractsApi): Promise<Contracts> => ({
  items: await Promise.all(contracts.items.map(normalizeContract)),
  totalCount: contracts.totalCount,
});
